<template>
  <section v-if="numberOfItems" data-cy="content-block">
    <div v-for="(block, url, index) in visibleItems" :key="url" class="pt-6 base-element">
      <div
        class="border-l-4 border-teal-500 px-4 py-3 shadow-md block-container"
        :key="url + '-' + index"
        role="alert"
        :data-cy="'content-block-child-' + index"
      >
        <div class="grid grid-row-4 grid-flow-col gap-1">
          <div class="py-1 svg-container">
            <information-circle-icon class="h-9 w-8 mr-4 svg-ico"></information-circle-icon>
          </div>
          <html-textarea :value="block" class="w-full self-center" data-cy="input"></html-textarea>
        </div>
      </div>
    </div>
  </section>
  <span>
    <!--
    Keep this empty span here, it's a long story:
    _withScopeId is not called when we don't have elements that should be hoisted to some scope thingy by vue.
    So we need to keep this span here, otherwise the coverage report will be missing some function calls.
    (keywords: _withScopeId, HOISTED, #__PURE__, Code coverage, ...)
    -->
  </span>
</template>

<script lang="ts" src="./ContentBlock.ts"></script>

<style scoped>
.base-element {
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}

.block-container {
  border-color: #2e84e7;
}

.svg-container {
  display: flex;
  align-items: center;
}

.svg-ico {
  color: #2e84e7;
}
</style>
